import { IVerifiedAddressData } from '@r1-frontend/entities/ContactAddress/initialState';

import { TCtxDispatch } from '~/src/features/tariffBuilder/Ctx';
import { TInitialState } from '~/src/features/tariffBuilder/reducer';

import createAgreement from './createAgreement';
import createRequestThunk from './createRequestThunk';


const initializationAgreement = (providerId: number, domain: string, address: IVerifiedAddressData, csrf: string) =>
    async(dispatch: TCtxDispatch, getState: () => TInitialState) => {
        const { currentTariff } = getState();

        if (currentTariff) {
            dispatch(createRequestThunk());
        } else if (address) {
            dispatch(createAgreement(providerId, domain, address, csrf));
        }
    };

export default initializationAgreement;
